<div class="aza-activities aza-vertical-stack">
    <div class="aza-activities-header aza-horizontal-stack">
        <div class="aza-activities-switch-buttons aza-flex-grow aza-horizontal-stack">
            <button (click)="onSwitchToList()" [ngClass]="{'aza-activities-selected-tab': visibility.list}"
                class="aza-activities-switch-button-list">
                <span translate>LIST</span>
            </button>
            <button *ngIf="visibility.details" [ngClass]="{'aza-activities-selected-tab': visibility.details}"
                class="aza-activities-switch-button-details">
                <span translate>DETAILS</span>
            </button>
        </div>
        <div class="aza-activities-search">
            <div
                class="aza-activity-list-search-input-with-image-container aza-horizontal-stack aza-vertical-items-centered">
                <input *ngIf="visibility.list" [(ngModel)]="quickSearchText" (input)="onSearchTextChanged()"
                    class="aza-activity-list-search-field" />
                <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"
                    class="aza-activity-list-search-input-img">
                    <path
                        d="m19.6 21-6.3-6.3q-.75.6-1.725.95Q10.6 16 9.5 16q-2.725 0-4.612-1.887Q3 12.225 3 9.5q0-2.725 1.888-4.613Q6.775 3 9.5 3t4.613 1.887Q16 6.775 16 9.5q0 1.1-.35 2.075-.35.975-.95 1.725l6.3 6.3ZM9.5 14q1.875 0 3.188-1.312Q14 11.375 14 9.5q0-1.875-1.312-3.188Q11.375 5 9.5 5 7.625 5 6.312 6.312 5 7.625 5 9.5q0 1.875 1.312 3.188Q7.625 14 9.5 14Z" />
                </svg>
            </div>
        </div>
    </div>
    <div *ngIf="eventSettings && visibility.list" class="aza-activity-list-container">
        <aza-rws-activity-list (activitySelected)="onActivitySelected($event)" [eventSettings]="eventSettings"
            [quickSearchText]="quickSearchText" [searchTextChanged]="searchTextChanged"
            [showActivitiesList]="showActivitiesList">
        </aza-rws-activity-list>
    </div>
    <div *ngIf="eventSettings && visibility.details" class="aza-activity-details">
        <aza-rws-activity-details [activity]="selectedActivity" [eventSettings]="eventSettings">
        </aza-rws-activity-details>
    </div>
</div>
